module.exports = __webpack_public_path__ + "img/23.4a86d42b.jpg";